import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const deleteDepartmentCategory = createServiceAsyncThunk<
  {
    status: boolean;
    message: string;
  },
  { id: number }
>(
  ACTION_NAMES.DELETE_DEPARTMENT_CATEGORY,
  ({ id }: { id: number }) =>
    departmentService.deleteDepartmentCategory({
      id,
    }),
  ERROR_MESSAGES.CREATE_DEPARTMENT_CATEGORY_FAILURE
);

const deleteDepartmentCategortSlice = createGenericSlice<
  { status: boolean; message: string },
  { id: number }
>(SLICE_NAMES.DELETE_DEPARTMENT_CATEGORY_SLICE, deleteDepartmentCategory);

export const {
  clearError: clearDeleteDepartmentCategoryError,
  clearSuccessMessage: clearDeleteDepartmentCategorySuccess,
} = deleteDepartmentCategortSlice.actions;

export default deleteDepartmentCategortSlice.reducer;
